import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firestoreConnect, isLoaded } from 'react-redux-firebase'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import { Link } from 'react-router-dom'
import Typography from '@material-ui/core/Typography';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from 'moment'
import CircularProgress from '@material-ui/core/CircularProgress'

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';

class Orders extends Component {

  state = {
    password: ''
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }

  render() {
    const { orders } = this.props

    if (!isLoaded) {
      return <Typography variant="h4" component="h3" gutterBottom align="center">
        <CircularProgress align="center" />
      </Typography>
    }

    if (this.state.password !== 'Admin@Anil~123') {
      return <div style={{width:400, margin:'100px auto 0'}}>
        <FormControl margin="normal" required fullWidth>
        <InputLabel htmlFor="password">Enter Password</InputLabel>
        <Input
          onChange={this.handleChange}
          value={this.state.password}
          multiline
          id="password" name="password" autoComplete="text" type="password" />
      </FormControl>
      </div>
    }



    return (
      <div style={{ width: '90%', margin: 'auto', marginTop: 20 }}>
        <Typography style={{ marginLeft: 10 }} variant="h4">Orders</Typography>
        <div style={{ clear: 'both', height: 1, width: '100%' }}></div>
        {
          orders &&
            orders.length > 0 ?

            <TableContainer style={{ marginTop: 20, marginBottom: 20 }} component={Paper}>
              <Table size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Mobile No</TableCell>
                    <TableCell>Delivery Address</TableCell>
                    <TableCell>Quantity</TableCell>
                    <TableCell>Any Message</TableCell>
                    <TableCell>Latitude</TableCell>
                    <TableCell>Longitude</TableCell>
                    <TableCell>Distance(KM)</TableCell>
                    <TableCell align="right">Created At</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>

                  {orders.map((order) => {
                    return (
                      <TableRow key={order.id}>
                        <TableCell>{order.name}</TableCell>
                        <TableCell>{order.mobileNo}</TableCell>
                        <TableCell>{order.deliveryAddress}</TableCell>
                        <TableCell>{order.quantity}</TableCell>
                        <TableCell>{order.anyMessage}</TableCell>
                        <TableCell>{order.latitude}</TableCell>
                        <TableCell>{order.longitude}</TableCell>
                        <TableCell>{order.distance.toFixed(2)}</TableCell>
                        <TableCell align="right">{order.createdAt ? moment(order.createdAt.toDate()).calendar() : ''}</TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            : <Typography variant="h5">There are no orders(s) to show</Typography>
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    orders: state.firestore.ordered.orders,
  }
}

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    return [
      {
        collection: 'orders',
        orderBy: ['createdAt', 'desc']
      }
    ]
  })
)(Orders)
